import { getLoopSelectedAtoms } from '@moleculeone/draw';
import { V4 } from '@moleculeone/utils';

import { MOL_MOUSE_EVENT, MOUSE_DOWN, MOUSE_MOVE, MOUSE_UP, SELECT_MODE } from '../../../../etc/constants';
import { updateSelected, updateState } from '../../../state';

export function effect(state, action) {
  if (action.type !== MOL_MOUSE_EVENT) {
    return {};
  }
  return baseEffect(state.mols, state.mode, state.selected, action.event, state.mouse.molIndex);
}

function baseEffect(mols, mode, selected, event, molIndex) {
  const data = mode.data;
  let newSelected = selected[molIndex];
  let newData = initial.data;

  if (event.type === MOUSE_DOWN && event.empty) {
    newData = { active: true, loop: [event.svgPos] };
    newSelected = event.ctrlKey ? newSelected : [];
  } else if (event.type === MOUSE_DOWN && event.atom) {
    newData = { active: false, loop: [] };
    if (!event.ctrlKey) {
      newSelected = [event.idx];
    } else {
      newSelected = [...newSelected];
      const idxPos = newSelected.indexOf(event.idx);
      if (idxPos === -1) {
        newSelected.push(event.idx);
      } else {
        newSelected.splice(idxPos, 1);
      }
    }
  } else if (event.type === MOUSE_DOWN && event.bond) {
    newData = { active: false, loop: [] };
    if (!event.ctrlKey) {
      newSelected = [event.start, event.end];
    } else {
      newSelected = [...newSelected];
      const idxPos1 = newSelected.indexOf(event.start);
      const idxPos2 = newSelected.indexOf(event.end);
      if (idxPos1 === -1 || idxPos2 === -1) {
        if (idxPos1 === -1) {
          newSelected.push(event.start);
        }
        if (idxPos2 === -1) {
          newSelected.push(event.end);
        }
      } else {
        newSelected.splice(newSelected.indexOf(event.start), 1);
        newSelected.splice(newSelected.indexOf(event.end), 1);
      }
    }
  } else if (event.type === MOUSE_UP && data.active === true) {
    newData = { active: false, loop: [] };
    newSelected = [...selected[molIndex], ...getLoopSelectedAtoms(mols[molIndex], data.loop)];
  } else if (event.type === MOUSE_MOVE && data.active === true) {
    const points = data.loop.slice();
    const length = points.length;
    if (length >= 2 && V4.dist(points[length - 2], points[length - 1]) < 10) {
      points.pop();
    }
    points.push(event.svgPos);
    newData = { active: true, loop: points };
  }

  const newMode = updateState(mode, { data: newData });
  return {
    mode: newMode,
    selected: updateSelected(selected, newSelected, molIndex),
  };
}

export function preview() {
  return null;
}

function cleanup(mode) {
  return mode;
}

const initial = {
  type: SELECT_MODE,
  data: { active: false, loop: [] },
};

export const trait = {
  type: SELECT_MODE,
  initial,
  effect,
  preview,
  cleanup,
};
